<template>
	<div class="weather_ui" :style="styleBg">
		<div class="weather_box" v-if="weather.type">
			<div class="weather_info" @click="toWeatherDetail" :style='fontWeight'>
				<div class="desc">{{datas.title}}</div>
				<div class="weather_detail">
					<img :src="weather.icon">
					<div class="weather_name">{{weather.type}}</div>
					<div class="weather_temperature">{{weather.average}}℃</div>
				</div>
			</div>
			<div class="hotel_info">
				<div class="hotel_phone" v-if="datas.phone"><i :style="iconColor" class="iconfont icondianhua3" @click.stop="makePhoneCall"></i></div>
				<div class="hotel_address"><i :style="iconColor" class="iconfont icondingwei" @click.stop="handleLocation"></i></div>
			</div>
		</div>
	</div>
	
</template>

<script>
	var config = {};
	
	import {
		setStorage,
		getStorage,
		openLocation
	} from "@/utils/wxuser";
	import api from "@/utils/api";
	import {
		jAlert3
	} from "@/base/jAlert/jAlert";
	export default {
		props: ["datas","hotelCode"],
		data() {
			return {
				hotel:{},
				weather:{},
				weatherList: [{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/大到暴雪.png',
						name: "大到暴雪"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/大到暴雨.png',
						name: "大到暴雨"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/大雪.png',
						name: "大雪"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/大雨.png',
						name: "大雨"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/多云.png',
						name: "多云"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/雷阵雨.png',
						name: "雷阵雨"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/霾.png',
						name: "霾"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/晴.png',
						name: "晴"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/雾.png',
						name: "雾"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/小到中雪.png',
						name: "小到中雪"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/小到中雨.png',
						name: "小到中雨"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/小雪.png',
						name: "小雪"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/雨夹雪.png',
						name: "雨夹雪"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/预警.png',
						name: "预警"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/阴.png',
						name: "阴"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/阵雨.png',
						name: "阵雨"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/中到大雪.png',
						name: "中到大雪"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/中到大雨.png',
						name: "中到大雨"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/中雪.png',
						name: "中雪"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/中雨.png',
						name: "中雨"
					},
					{
						icon: 'https://xcx.ihotel.cn/mall/images/weather/小雨.png',
						name: "小雨"
					},
				]
			};
		},
		computed: {
			styleBg(){
				return `background:${this.datas.bgColor};`
			},
			iconColor(){
				return `color:${this.datas.iconColor}`
			},
			fontWeight(){
				return `font-weight:${this.datas.fontWeight}`
				
			}
		},
		methods: {
			toWeatherDetail(){
				this.$router.push({
					path:"/weatherDetail",
					query:{
						city:this.hotel.city
					}
				})
			
			},
			handleLocation() {
				var lat = this.hotel.hotelLatitude
				var lon = this.hotel.hotelLongitude
				var address = this.hotel.address1
				if(this.datas.lat&&this.datas.lat!==''){
					lat = this.datas.lat
					lon = this.datas.lon
				}
				if(this.datas.province||this.datas.city||this.datas.address){
					address = `${this.datas.province}${this.datas.city}${this.datas.address}`
				}
				if (lat) {
					openLocation({
						name: this.hotel.descript,
						address: address,
						latitude: lat,
						longitude: lon,
						scale: 28,
			
					});
				}
				
			
			},
			makePhoneCall() {
				 window.location.href = "tel:" + this.datas.phone
			},
			getHotelInfo() {
				var opt = {
					hotelGroupCode: config.hotelGroupCode,
					hotelCode: this.hotelCode
				}
				api.getHotelInfo(opt).then(res => {
					if (res.result == 1) {
						this.hotel = res.retVal[0]
						var city = res.retVal[0].city
						api.getWetherList({
				
							cityName:city
						}).then(res => {
							if (res.result == 1) {
								if(res.retVal.length>0){
									this.weather =res.retVal[0]
									this.weather.average = Math.round((this.weather.high + this.weather.low)/2)
									this.weatherList.forEach(item=>{
										
										if(item.name==this.weather.type){
											this.weather.icon = item.icon
										}
									})
									if(!this.weather.icon){
										this.weatherList.forEach(item=>{
											if(item.name=='预警'){
												this.weather.icon = item.icon
											}
										})
										
									}
								}
								
							}else {
								jAlert3(res.msg)
							}
						})

					} else {
						jAlert3(res.msg)
					}
				})
			},
		},
		mounted() {
			console.log(this.datas)
			config = getStorage("config");
			this.getHotelInfo()


		}


	};
</script>

<style lang="less" scoped>
	@import url("~@/styles/mixin.less");

	.weather_ui {

		padding: 0 0.3999rem;

		.weather_box {
			background: #FFFFFF;
			box-shadow: 0px 0.15996rem 0.31992rem 0px rgba(0, 0, 0, 0.06);
			border-radius: 0.2666rem;
			padding: 0.2666rem 0.31992rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.weather_info {
				display: flex;
				flex: 1;
				flex-direction: column;
				padding-right: 0.1333rem;

				.desc {
					font-size: 12px;
					color: #333333;
					line-height: 0.453rem;
					max-height: 0.906rem;
					 display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    white-space: normal;
                    word-break: break-all;
				}

				.weather_detail{
					display: flex;
					align-items: center;
					margin-top: 0.1333rem;
					img{
						width: 0.47988rem;
						height: 0.47988rem;
					}
					.weather_name,.weather_temperature{
						
						font-size: 12px;
						color: #333333;
						margin-left: 0.23994rem;
	
					}
				}
			}
			.hotel_info{
				border-left: 1px solid #eee;
				height: 0.5332rem;
				display: flex;
				align-items: center;
				padding-left: 0.31992rem;
				i{
					font-size: 18px;
					padding: 0 0.31992rem;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/Weather.vue